export enum TagEnum {
  INTERESTING = "interesting",
  CASE_OPENED = "case_opened",
}
